import { create } from 'zustand';

export interface GlitchTransitionStoreType {
  isPlaying: boolean;
  play: () => void;
  setIsPlaying: (isPlaying: boolean) => void;
}

export const useGlitchTransitionStore = create<GlitchTransitionStoreType>(
  set => ({
    isPlaying: false,
    play: () => set({ isPlaying: true }),
    setIsPlaying: isPlaying => set({ isPlaying }),
  })
);
